import { createSlice } from "@reduxjs/toolkit";

export interface appLoaderSliceState {
  isLoading: boolean;
}

export const appLoaderSlice = createSlice({
  name: "appLoaderSlice",
  initialState: {
    isLoading: false
  },
  reducers: {
    setIsLoading(state, action) {
      const newState = { ...state };
      newState.isLoading = action.payload;
      return newState;
    }
  }
});

export const { actions: appLoaderActions, reducer: appLoaderReducers } =
  appLoaderSlice;
